import { Typography } from "@mui/material";
import { MetaValuePreviewProps } from "pages/AttributesPage/CustomAttributeComponents/metaValueComponents";

export function TextFieldPreview({
  metaValueName,
  attributeMetaValues,
}: MetaValuePreviewProps) {
  const value = attributeMetaValues?.find(
    (m) => m.name === metaValueName,
  )?.value;

  if (!value) return null;

  return <Typography variant="body2">{value}</Typography>;
}
